// Fetch Student Profile
import * as types from './_actionTypes';

export const fetchStudentProfileRequest = (userId) => ({
  type: types.FETCH_STUDENT_PROFILE_REQUEST,
  payload: userId
});

export const fetchStudentProfileSuccess = (profile) => ({
  type: types.FETCH_STUDENT_PROFILE_SUCCESS,
  payload: profile
});

export const fetchStudentProfileFailure = (error) => ({
  type: types.FETCH_STUDENT_PROFILE_FAILURE,
  payload: error
});

// Update Student Profile


export const updateStudentProfileRequest = (userId, data) => ({
  type: types.UPDATE_STUDENT_PROFILE_REQUEST,
  payload: { userId, data }
});

export const updateStudentProfileSuccess = (profile) => ({
  type: types.UPDATE_STUDENT_PROFILE_SUCCESS,
  payload: profile
});

export const updateStudentProfileFailure = (error) => ({
  type: types.UPDATE_STUDENT_PROFILE_FAILURE,
  payload: error
});

// Update Student DOB
export const updateStudentDOBRequest = (dob) => ({
  type: types.UPDATE_STUDENT_DOB_REQUEST,
  payload: { dob }
});

export const updateStudentDOBSuccess = (data) => ({
  type: types.UPDATE_STUDENT_DOB_SUCCESS,
  payload: data
});

export const updateStudentDOBFailure = (error) => ({
  type: types.UPDATE_STUDENT_DOB_FAILURE,
  payload: error
});
